import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import SocialMediaLinks from "@one-builder/gatsby-theme-ob-master/src/components/social-links"
import Logo from "@one-builder/gatsby-theme-ob-master/src/components/logo"
import Navigation from "@one-builder/gatsby-theme-ob-master/src/components/layout/navigation/navigation"
import { FaPhone } from "react-icons/fa"
import Headroom from "react-headroom"
import AlertBanner from "@one-builder/gatsby-theme-ob-master/src/components/layout/alert-banner"

import styles from "@one-builder/gatsby-theme-ob-master/src/styles/global.module.scss"
import headerStyles from "../../styles/global.module.scss"

import { GoTriangleRight } from "react-icons/go"

const Header = ({ metadata }) => {
  return (
    <Headroom>
      <AlertBanner metadata={metadata} />
      <div className={headerStyles.topBar}>
        <div className={headerStyles.container}>
        <Navigation />
          <div className={headerStyles.sub}>
            <span>
              Phone:{"  "}
              <strong><a
                href={`tel:${metadata.CompanyPhone}`}
                title={metadata.CompanyPhone}
              >
                {metadata.CompanyPhone}
              </a></strong>
            </span>
          </div>
          <div className={headerStyles.sub}>
            <SocialMediaLinks />
          </div>
        </div>
      </div>
      <header className={headerStyles.header}>
        <div
          className={`${headerStyles.container} ${headerStyles.flexWrapper}`}
        >
          <div className={headerStyles.logo}>
            <Link
              aria-label={metadata.CompanyName}
              alt={metadata.CompanyName}
              to="/"
            >
              <Logo />
            </Link>
          </div>
          <div className={styles.headerCta}>
            <div className={styles.hpBtns}>
                <Link to="/request-a-quote/" title="Schedule Service">
                  Schedule Service <GoTriangleRight />
                </Link>
            </div>
            <p>Fully Insured and licensed in PA PAHIC #145446</p>
          </div>
        </div>
      </header>
    </Headroom>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
